import { convertToTag } from './tags';
import type { Organization, UserProfileWithSelection, UserProfile } from './types';
import type { ApiOrganization } from './apiTypes';

export function convertToOrganization(orgResponseObject: ApiOrganization): Organization {
  const availableTags = orgResponseObject.available_tags || [];

  return {
    id: orgResponseObject.organization_id,
    code: orgResponseObject.organization_code.toString(),
    name: orgResponseObject.organization_name,
    templatePreferences: orgResponseObject.template_preferences,
    availableTags: availableTags.map((tagObj) => convertToTag(tagObj)),
  };
}

export function extractOrganizationNames(
  pendingUsers: UserProfileWithSelection[],
  networkUserMap: Map<number, UserProfile>,
  organizations: Organization[],
): Record<string, string> {
  const organizationIds = new Set<number>();

  for (const user of pendingUsers) {
    const networkProfile = networkUserMap.get(user.userId);
    if (networkProfile?.organizationId) {
      organizationIds.add(networkProfile.organizationId);
    }
  }

  const organizationNames: Record<string, string> = {};

  for (const orgId of organizationIds) {
    const organization = organizations.find((org) => org.id === orgId);
    if (organization) {
      organizationNames[orgId.toString()] = organization.name;
    } else {
      organizationNames[orgId.toString()] = 'Unknown Organization';
    }
  }

  const hasUsersWithNoOrg = pendingUsers.some((user) => {
    const networkProfile = networkUserMap.get(user.userId);
    return !networkProfile?.organizationId;
  });

  if (hasUsersWithNoOrg) {
    organizationNames['no-organization'] = 'No Organization';
  }

  return organizationNames;
}
